import type { TooltipComponentProps } from "../types";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/v2/tooltip";

/**
 * TooltipComponent - wraps a trigger component with tooltip content.
 * The content receives the same data context as the tooltip itself.
 */
function TooltipComponent({
  trigger,
  content,
  renderChild,
  renderWithContext,
  data,
}: TooltipComponentProps) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span>{renderChild(trigger)}</span>
      </TooltipTrigger>
      <TooltipContent>
        {renderWithContext(content, { data })}
      </TooltipContent>
    </Tooltip>
  );
}

export { TooltipComponent };
